function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgNight1 = function SvgNight1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.016 480.016",
    style: {
      enableBackground: "new 0 0 480.016 480.016"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M426.224,363.84c-1.12,0-42.648,0-42.648,0c0.744-8.16,1.24-9.968,1.256-14.744 c0.128-42.672-28.36-80.592-70.032-89.776c-23.752-5.232-46.432-1.68-65.192,8.44c-22.888-34.064-60.816-57.2-104.272-59.856 c-5.592-0.768-11.256-1.304-17.056-1.304C57.432,206.6,0,265.832,0,338.888c0,38.072,15.688,72.288,40.648,96.424 c22.072,24.488,52.72,40.304,89.008,42.936c0,0,295.448,1.464,296.568,1.464c29.712,0,53.792-25.936,53.792-57.936 C480.016,389.776,455.936,363.84,426.224,363.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCE674"
    },
    d: "M363,1.976c10.28,17.208,16.304,37.264,16.304,58.768c0,63.44-51.432,114.872-114.872,114.872 c-0.144,0-0.28-0.024-0.424-0.024c20.056,33.568,56.632,56.112,98.576,56.112c63.44,0,114.872-51.432,114.872-114.872 C477.456,53.528,426.248,2.208,363,1.976z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCE674"
    },
    points: "76.552,149.28 91.56,179.696 125.128,184.576 100.84,208.248 106.576,241.68  76.552,225.896 46.528,241.68 52.264,208.248 27.976,184.576 61.544,179.696  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCE674"
    },
    points: "192.416,0.304 207.432,30.72 241,35.6 216.712,59.28 222.44,92.704 192.416,76.92  162.4,92.704 168.128,59.28 143.84,35.6 177.408,30.72  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNight1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/night-1.6de43503.svg";
export { ForwardRef as ReactComponent };